<!-- FORMULARIO DINAMICO -->
<div [formGroup]="parentForm">
  <div class="row p-2"></div>
  <div class="row p-2" *ngFor="let p of preguntas" >
    <div class="col-md-6"><label><span>{{p.orden}}. {{ p.itemPregunta }}</span></label></div>
    
    <ng-container [ngSwitch]="p.tipoRespuesta">
      <!--<input type="text" [formControlName]="p.renderControl" class="form-control col"/>-->

      <div class="col-md-6" *ngSwitchCase="'NUMBER'">
        <input type="number" [formControlName]="p.renderControl" class="form-control col"/>
      </div>

      <div class="col-md-6" *ngSwitchCase="'TEXT'">
        <input type="text" [formControlName]="p.renderControl" class="form-control col"/>
      </div>

      <div class="col-md-6" *ngSwitchCase="'SI_NO_NA'">
        <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="{{ p.renderControl }}" id="inline1_{{p.renderControl}}" value="1" [formControlName]="p.renderControl">
            <label class="form-check-label" for="inline1_{{p.renderControl}}">SI</label>
        </div>
        <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="{{ p.renderControl }}" id="inline2_{{p.renderControl}}" value="0" [formControlName]="p.renderControl">
            <label class="form-check-label" for="inline2_{{p.renderControl}}">NO</label>
        </div>
        <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="{{ p.renderControl }}" id="inline3_{{p.renderControl}}" value="2" [formControlName]="p.renderControl">
            <label class="form-check-label" for="inline3_{{p.renderControl}}">NA</label>
        </div>
      </div>

    </ng-container>
  </div>
</div>
